module.exports = __webpack_public_path__ + "img/vegetable-chicories-190x100.1e634361.jpg";